<div class="audit-grid-container">
  <!-- HEADER GROUP ROW -->
  @if (isExistingHeaderVisible) {
    <app-after-2017-header
      [screenVisible]="screen"
      [headerColumns]="displayColumns"
      [gridColumnsTemplate]="baseGridTemplate"
    >
    </app-after-2017-header>
  }

  <div class="after2017-records">
    @for (record of records; track record.id; let recordIndex = $index) {
      <div class="record-wrapper" [class.all-issues-record]="screen === 'allIssues'">
        <div
          class="record-container"
          [ngClass]="{
            'cancel-record': record.isCancelled,
          }"
        >
          @for (row of record.rows; track $index; let rowIndex = $index) {
            @if (shouldDisplayRow(rowIndex, record.rows.length)) {
              <div
                class="data-row"
                [style.grid-template-columns]="after2017TemplateRecords"
                [ngClass]="action === 'edit' ? 'CustomAfter2017TableBG' : ''"
              >
                <!-- 1. Issue ID / Year / Entity -->
                @if (this.screen === 'allIssues') {
                  <div class="cell">
                    @switch (rowIndex) {
                      @case (0) {
                        <p>{{ record.issueId }}</p>
                      }
                      @case (1) {
                        <p>{{ record.year }}</p>
                      }
                      @case (2) {
                        <p>{{ record.entity }}</p>
                      }
                      @case (4) {
                        <p>{{ record.cfc }}</p>
                      }
                    }
                  </div>
                }

                <!-- 2. TI / FTC / GBC / NOTE -->
                <h2 class="row-heading" id="labels">
                  {{ row.label }}
                </h2>

                <!-- 3. US -->
                <div class="cell">
                  @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'GBC')) {
                    <input
                      type="text"
                      [ngModel]="row.us"
                      (ngModelChange)="onGbcUsChanged(row, record, $event)"
                      (keydown)="allowIntegerInput($event, row.us ?? '')"
                      (paste)="handleIntegerPaste($event, row, 'us', record)"
                      (drop)="handleIntegerDrop($event, row, 'us', record)"
                    />
                  } @else {
                    <p>{{ row.us }}</p>
                  }
                </div>

                <!-- 4. Branch -->
                <div class="group-cell">
                  <div>
                    @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')) {
                      <input
                        type="text"
                        [ngModel]="row.branchNogi"
                        (ngModelChange)="updateCellValue(row, 'branchNogi', $event)"
                        (keydown)="allowIntegerInput($event, row.branchNogi ?? '')"
                        (paste)="handleIntegerPaste($event, row, 'branchNogi')"
                        (drop)="handleIntegerDrop($event, row, 'branchNogi')"
                      />
                    } @else {
                      <p>{{ row.branchNogi }}</p>
                    }
                  </div>

                  <div>
                    @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')) {
                      <input
                        type="text"
                        [ngModel]="row.branchCfogi"
                        (ngModelChange)="updateCellValue(row, 'branchCfogi', $event)"
                        (keydown)="allowIntegerInput($event, row.branchCfogi ?? '')"
                        (paste)="handleIntegerPaste($event, row, 'branchCfogi')"
                        (drop)="handleIntegerDrop($event, row, 'branchCfogi')"
                      />
                    } @else {
                      <p>{{ row.branchCfogi }}</p>
                    }
                  </div>
                </div>

                <!-- 5. No Branch -->
                <div class="group-cell">
                  <div>
                    @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')) {
                      <input
                        type="text"
                        [ngModel]="row.nonBranchNogi"
                        (ngModelChange)="updateCellValue(row, 'nonBranchNogi', $event)"
                        (keydown)="allowIntegerInput($event, row.nonBranchNogi ?? '')"
                        (paste)="handleIntegerPaste($event, row, 'nonBranchNogi')"
                        (drop)="handleIntegerDrop($event, row, 'nonBranchNogi')"
                      />
                    } @else {
                      <p>{{ row.nonBranchNogi }}</p>
                    }
                  </div>

                  <div>
                    @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')) {
                      <input
                        type="text"
                        [ngModel]="row.nonBranchCfogi"
                        (ngModelChange)="updateCellValue(row, 'nonBranchCfogi', $event)"
                        (keydown)="allowIntegerInput($event, row.nonBranchCfogi ?? '')"
                        (paste)="handleIntegerPaste($event, row, 'nonBranchCfogi')"
                        (drop)="handleIntegerDrop($event, row, 'nonBranchCfogi')"
                      />
                    } @else {
                      <p>{{ row.nonBranchCfogi }}</p>
                    }
                  </div>
                </div>

                <!-- 6. Passive -->
                <div class="cell">
                  @if (action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')) {
                    <input
                      type="text"
                      [ngModel]="row.passive"
                      (ngModelChange)="updateCellValue(row, 'passive', $event)"
                      (keydown)="allowIntegerInput($event, row.passive ?? '')"
                      (paste)="handleIntegerPaste($event, row, 'passive')"
                      (drop)="handleIntegerDrop($event, row, 'passive')"
                    />
                  } @else {
                    <p>{{ row.passive }}</p>
                  }
                </div>

                <!-- 7. GILTI -->
                <div class="group-cell">
                  @if (row.npaLast && row.giltiFori === 'NPA ties AR/SAA') {
                    <h2 id="npa-full-width">
                      {{ row.giltiFori }}
                    </h2>
                  } @else {
                    <div>
                      @if (
                        action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')
                      ) {
                        <input
                          type="text"
                          [ngModel]="row.giltiNogi"
                          (ngModelChange)="updateCellValue(row, 'giltiNogi', $event)"
                          (keydown)="allowIntegerInput($event, row.giltiNogi ?? '')"
                          (paste)="handleIntegerPaste($event, row, 'giltiNogi')"
                          (drop)="handleIntegerDrop($event, row, 'giltiNogi')"
                        />
                      } @else {
                        <p>{{ row.giltiNogi }}</p>
                      }
                    </div>

                    <div>
                      @if (
                        action === 'edit' && (row.label === 'TI b/f 199' || row.label === 'FTC')
                      ) {
                        <input
                          type="text"
                          [ngModel]="row.giltiFori"
                          (ngModelChange)="updateCellValue(row, 'giltiFori', $event)"
                          (keydown)="allowIntegerInput($event, row.giltiFori ?? '')"
                          (paste)="handleIntegerPaste($event, row, 'giltiFori')"
                          (drop)="handleIntegerDrop($event, row, 'giltiFori')"
                        />
                      } @else {
                        <p>{{ row.giltiFori }}</p>
                      }
                    </div>
                  }
                </div>

                <!-- 8. Capital Gain -->
                <div class="cell">
                  @if (action === 'edit' && row.label === 'TI b/f 199') {
                    <input
                      type="text"
                      [ngModel]="row.capitalGain"
                      (ngModelChange)="updateCellValue(row, 'capitalGain', $event)"
                      (keydown)="allowIntegerInput($event, row.capitalGain ?? '')"
                      (paste)="handleIntegerPaste($event, row, 'capitalGain')"
                      (drop)="handleIntegerDrop($event, row, 'capitalGain')"
                    />
                  } @else {
                    <p>{{ row.capitalGain }}</p>
                  }
                </div>

                @if (this.screen === 'allIssues') {
                  <!-- 9. AR Filing ID / AR Issue ID / IRS Issue ID -->
                  <div class="cell">
                    @switch (rowIndex) {
                      @case (0) {
                        <p>{{ record.arFilingId }}</p>
                      }

                      @case (1) {
                        <p>{{ record.arIssueId }}</p>
                      }

                      @case (2) {
                        <p>{{ record.irsIssueID }}</p>
                      }

                      @case (3) {
                        <p>{{ record.status }}</p>
                      }
                    }
                  </div>

                  <!-- 10. SAA # / Submission / SP Doc -->
                  <div class="cell">
                    @if (rowIndex === 0) {
                      <p>{{ record.saaID }}</p>
                    }

                    @if (rowIndex === 1) {
                      <p>{{ record.saaSubmission }}</p>
                    }

                    @if (rowIndex === 2) {
                      @let spDocLink = getSpDocLink(record.docID);
                      @if (spDocLink.isClickable) {
                        <p
                          class="linkBTN"
                          id="link"
                          role="link"
                          tabindex="0"
                          [title]="spDocLink.title"
                          (click)="navigateToLink(record.docID ?? '')"
                          (keydown)="onLinkKeydown($event, record.docID ?? '')"
                        >
                          {{ spDocLink.displayText }}
                        </p>
                      } @else if (spDocLink.displayText) {
                        <p
                          class="linkBTN"
                          id="link"
                          [title]="spDocLink.title"
                          style="cursor: default"
                        >
                          {{ spDocLink.displayText }}
                        </p>
                      }
                    }

                    @if (rowIndex === 3) {
                      <div class="d-Flex linkBTN" id="NPARow">
                        <h2 id="npaHeading">NPA</h2>
                        <p class="pl-5 linkBTN" [title]="record.npa">
                          {{ record.npa }}
                        </p>
                      </div>
                    }

                    @if (rowIndex === 4) {
                      <div class="d-Flex gap-2 justify-content-center">
                        @if (record.saaChecked) {
                          <div class="image-checkbox-checked" [class.checked]="true">✓</div>
                        } @else {
                          <div class="image-checkbox-unchecked" [class.checked]="false"></div>
                        }
                        <h2>ASC 740</h2>
                      </div>
                    }
                  </div>

                  <!-- 11. E&P Adj / TBBS Adj / Corptax Adj -->
                  <div class="cell">
                    @if (rowIndex === 0) {
                      <p>{{ record.isEPAdjRequired }}</p>
                    }

                    @if (rowIndex === 1) {
                      <p>{{ record.isTBBSAdjRequired }}</p>
                    }

                    @if (rowIndex === 2) {
                      <p>{{ record.dateCorptaxAdj }}</p>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>

        <!-- Action Buttons: EDIT, ADD, DELETE -->
        @if (screen === 'allIssues') {
          <div class="actionColumn custom-icons gap-2">
            <!-- Audit Trail Records -->
            <button
              type="button"
              class="btn btn-link p-0 successIcon iconCSS"
              (click)="showAudit(record)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                stroke-width="1.75"
              >
                <title>Audit Trail Records</title>
                <path d="M4 3h11l5 5v13H4z" fill="#f8f8f8" stroke="#0b2d71" />
                <circle cx="8" cy="10" r="1.2" fill="#0b2d71" />
                <circle cx="8" cy="14" r="1.2" fill="#0b2d71" />
                <circle cx="8" cy="18" r="1.2" fill="#0b2d71" />
                <line x1="8" y1="10" x2="8" y2="18" stroke="#0b2d71" />
                <line x1="11" y1="10" x2="17" y2="10" stroke="#0b2d71" />
                <line x1="11" y1="14" x2="17" y2="14" stroke="#0b2d71" />
                <line x1="11" y1="18" x2="15" y2="18" stroke="#0b2d71" />
              </svg>
            </button>

            @if (showHideIcons) {
              <!-- Edit -->
              <button
                type="button"
                class="btn btn-link p-0 successIcon iconCSS"
                (click)="editRecord(record)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="21"
                  height="21"
                  fill="none"
                  stroke="#0b2d71"
                  stroke-width="2.2"
                >
                  <title>Edit Record</title>
                  <path
                    d="M3 17.25V21h3.75L17.8 9.94l-3.75-3.75L3 17.25zm17.71-10.04a1.003 1.003 0 0 0 0-1.42l-2.5-2.5a1.003 1.003 0 0 0-1.42 0l-1.96 1.96 3.75 3.75 2.13-1.79z"
                  />
                </svg>
              </button>

              <!-- Delete -->
              <button
                type="button"
                class="btn btn-link p-0 dangerIcon iconCSS"
                (click)="deleteRecord(record)"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="rotate: -5deg"
                >
                  <title>Cancel Record</title>
                  <path
                    d="M6 6L18 18M18 6L6 18"
                    stroke="#0F3D8F"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
